module.exports = __webpack_public_path__ + "static/media/fire.c4616cba.svg";